// extracted by mini-css-extract-plugin
module.exports = {"bottomBar":"footer--bottom-bar_bottomBar__Tp5SP","bottomBarContainer":"footer--bottom-bar_bottomBarContainer__z3wJD"};